/**
 * Метка почасового архива Энергосферы стоит на правой границе часа.
 * «01.09.2026 00:00» — это час 31.08 23:00–24:00.
 * @returns {{dat_local: string, dat_out: string, dayKey: string}|null}
 */
export function shiftEnergosferaHourLeft(stamp) {
    const m = String(stamp ?? '').match(/(\d{2})\.(\d{2})\.(\d{4})\s+(\d{2}):(\d{2})/)
    if (!m) return null
    const d = new Date(Date.UTC(Number(m[3]), Number(m[2]) - 1, Number(m[1]), Number(m[4]), Number(m[5])))
    d.setUTCHours(d.getUTCHours() - 1)
    const p = (n) => String(n).padStart(2, '0')
    const day = `${d.getUTCFullYear()}-${p(d.getUTCMonth() + 1)}-${p(d.getUTCDate())}`
    const hm = `${p(d.getUTCHours())}:${p(d.getUTCMinutes())}`
    return {
        dat_local: `${p(d.getUTCDate())}.${p(d.getUTCMonth() + 1)}.${d.getUTCFullYear()} ${hm}`,
        dat_out: `${day}T${hm}:00`,
        dayKey: day,
    }
}

export function periodDayKey(date) {
    const p = (n) => String(n).padStart(2, '0')
    return `${date.getFullYear()}-${p(date.getMonth() + 1)}-${p(date.getDate())}`
}

export function getFirstDayOfMounth(date) {
    date.setDate(1)
    date.setUTCHours(0)
    date.setMinutes(0)
    date.setSeconds(0)
    date.setMilliseconds(0)
    return date
}

export function getLastDayOfMounth(date, isNextPeriod = true) {//берем или начало следующего периода, или последний день текущего
    //ставим начало следующего периода, чтобы захватить последний день месяца
    var d = new Date(date.getFullYear(), date.getUTCMonth() + 1, (isNextPeriod ? 2 : 1))
    d.setUTCHours(0)
    d.setMinutes(0)
    d.setSeconds(0)
    d.setMilliseconds(0)
    return d
}

export function getFirstDayOfMounthAndHours000000WithoutUTC(date) {
    //первый день месяца и время 00:00:00
    var d = new Date(date.getFullYear(), date.getMonth(), 1)
    d.setHours(0)
    d.setMinutes(0)
    d.setSeconds(0)
    d.setMilliseconds(0)
    return d
}

export function getLastDayOfMounthAndHours230000WithoutUTC(date) {
    //последний день месяца и время 23:00:00
    var d = new Date(date.getFullYear(), date.getMonth() + 1, 0)
    d.setHours(23)
    d.setMinutes(0)
    d.setSeconds(0)
    d.setMilliseconds(0)
    return d
}

export function getLastDayOfMounthAndHours235959WithoutUTC(date) {
    //последний день месяца и время 23:00:00
    var d = new Date(date.getFullYear(), date.getMonth() + 1, 0)
    d.setHours(23)
    d.setMinutes(59)
    d.setSeconds(59)
    d.setMilliseconds(0)
    return d
}

export function getYm(date) {
    date = new Date(date)
    const ym = date.getFullYear() + '.' + (date.getMonth() + 1).toString().padStart(2,'0')
    return ym
}

export function getFirstDayOfMounthFix(date) {
    var d = new Date(date.getFullYear(), date.getMonth(), 2)
    d.setUTCHours(0)
    d.setMinutes(0)
    d.setSeconds(0)
    d.setMilliseconds(0)
    return d
}

export function getMonthShortAndYearFourDigit(value) {
    let date = new Date(value);
    const month = date.toLocaleString('default', { month: 'long' });
    const year = date.toLocaleString('default', { year: 'numeric' });
    return month + ' ' + year;
}

export function getMonthTwoDigitAndYearFourDigit(date) {
    date = new Date(date)
    return ((date.getMonth()+1).toString().padStart(2, '0'))  + '-' +  date.getFullYear()
}

export function getyyyyMMdd(date) {
    return date.getFullYear() + '-' + (date.getMonth()+1).toString().padStart(2, '0') + '-' + date.getDate().toString().padStart(2, '0')
}

export function getyyyMMddHHmm(date) {
    date = new Date(date)
    return (date.getFullYear() + '-' + (date.getMonth()+1).toString().padStart(2, '0')
        + '-' + date.getDate().toString().padStart(2, '0')
        + ' ' + date.getHours().toString().padStart(2, '0')
        + ':' + date.getMinutes().toString().padStart(2, '0'))
}

export function getddMMyyyyHHmm(date) {
    date = new Date(date)
    return (date.getDate().toString().padStart(2, '0') + '-' + (date.getMonth()+1).toString().padStart(2, '0')
        + '-' + date.getFullYear()
        + ' ' + date.getHours().toString().padStart(2, '0')
        + ':' + date.getMinutes().toString().padStart(2, '0'))
}

export function getHHmmddMMyyyy(date) {
    date = new Date(date)
    return (date.getHours().toString().padStart(2, '0')
        + ':' + date.getMinutes().toString().padStart(2, '0'))
        + ' ' + date.getDate().toString().padStart(2, '0') + '.' + (date.getMonth()+1).toString().padStart(2, '0')
        + '.' + date.getFullYear()
}

export function getddMMyyyy(date) {
    date = new Date(date)
    return (date.getDate().toString().padStart(2, '0') + '-' + (date.getMonth()+1).toString().padStart(2, '0')
        + '-' + date.getFullYear())
}

/**
 * Настройки планирования (correction_time / auto_send_time) заданы как часы МСК.
 * Для подписи на экране переводим в часовой пояс ОС браузера.
 * @returns {string} HH:MM
 */
export function formatMskClockLocal(hour, min) {
    const h = Number(hour)
    const m = Number(min)
    const safeH = Number.isNaN(h) ? 0 : h
    const safeM = Number.isNaN(m) ? 0 : m
    const mskDate = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Europe/Moscow',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    }).format(new Date())
    const hh = String(safeH).padStart(2, '0')
    const mm = String(safeM).padStart(2, '0')
    const instant = new Date(`${mskDate}T${hh}:${mm}:00+03:00`)
    return `${String(instant.getHours()).padStart(2, '0')}:${String(instant.getMinutes()).padStart(2, '0')}`
}
